export const APP_BACKEND_FUNCTION_NAME = 'lol-explainer-app_backend' as string;
export const APP_BACKEND_URL = 'https://lol.matthis.link/' as string;
export const APP_BACKEND_ROLE_ARN =
  'arn:aws:iam::982619301361:role/lol-explainer-app_backend-role' as string;
export const APP_FRONTEND_CLOUDFRONT_DOMAIN_NAME = 'static.lol.matthis.link' as string;
export const CURRENT_ENV = '982619301361' as string;
export const REGION = 'eu-west-3' as string;
export const ACCOUNT_ID = '982619301361' as string;
export const CODE_BUCKET = 'lol-explainer-code-20241019091818746100000002' as string;
export const CHAT_GPT_CACHE_TABLE_NAME = 'ChatGptCache' as string;
